export default __webpack_public_path__ + "static/media/PortfolioProject6.b498aed3.png";